module.exports = __webpack_public_path__ + "static/img/search.e09c1818.svg";